module.exports = __webpack_public_path__ + "img/DISABLE.681a0555.svg";